function isTouchInteraction() {
  // Check if the device supports touch
  const hasTouch = 'ontouchstart' in window ||
    (window.DocumentTouch && document instanceof DocumentTouch);
    
  // Check if we have a mouse connected
  const hasMouse = window.matchMedia('(pointer:fine)').matches;
  
  // If we have both touch and mouse, we'll consider it a non-touch interaction
  // This helps with devices like laptops with touch screens where mouse is primary
  return hasTouch && !hasMouse;
}

export default isTouchInteraction; 
